













































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import MultiSelect from 'vue-multiselect';
import cloneDeep from 'lodash/cloneDeep';
import ProjectsData from '@/ts/ProjectsData';
import BuildingData from '@/ts/BuildingData';
import PropertyData from '@/ts/PropertyData';

@Component({
    components: {
        MultiSelect,
    },
})
export default class Recipients extends Vue {
    public search: any = '';
    public preselectedUnitIds: any[] = [];
    public recipientsSelectedProjects: any[] = [];
    public recipientsSelectedGroups: any[] = [];
    public recipientsSelectedUnits: any[] = [];
    public noRecipientsError: boolean = false;

    constructor() {
        super();
    }

    get preselectedActionTargets() {
        return {
            projects: this.$store.getters['Projects/selectedProjects'],
            groups: this.$store.getters['Buildings/selectedBuildings'],
            units: this.$store.getters['Properties/selectedProperties'],
        };
    }

    get recipientSelected(): boolean {
        return (
            this.recipientsSelectedProjects.length > 0 ||
            this.recipientsSelectedGroups.length > 0 ||
            this.recipientsSelectedUnits.length > 0
        );
    }

    get isForWholeCorporation(): boolean {
        return this.$store.getters['Recipients/getForWholeCorporation'];
    }

    get recipientRequired(): boolean {
        return this.$store.getters['Recipients/getRecipientRequired'];
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    get buildings(): BuildingData[] {
        return this.$store.getters['Buildings/allBuildings'];
    }

    get properties(): PropertyData[] {
        const allProperties = this.$store.getters['Properties/allProperties'];

        if (this.search.trim() !== '') {
            return allProperties.filter((property: PropertyData) => {
                const propertyOwnerName = this.getPropertyOwner(property);

                const checkForId   = property.id === this.search;
                const addressCheck = property.address.includes(this.search);
                const ownerCheck   = propertyOwnerName.includes(this.search);

                return checkForId || addressCheck || ownerCheck;
            });
        }

        return allProperties;
    }

    @Watch('recipientsSelectedProjects')
    public recipientsSelectedProjectsChanged() {
        this.noRecipientsError = false;

        if (this.recipientSelected) {
            this.$store.commit(Mutations.SET_FOR_WHOLE_CORPORATION, false);
        }
    }

    @Watch('recipientsSelectedGroups')
    public recipientsSelectedGroupsChanged() {
        this.noRecipientsError = false;

        if (this.recipientSelected) {
            this.$store.commit(Mutations.SET_FOR_WHOLE_CORPORATION, false);
        }
    }

    @Watch('recipientsSelectedUnits')
    public recipientsSelectedUnitsChanged() {
        this.noRecipientsError = false;

        if (this.recipientSelected) {
            this.$store.commit(Mutations.SET_FOR_WHOLE_CORPORATION, false);
        }
    }

    public getPropertyOwner(unit: PropertyData): string {
        if (unit.isCommercial) {
            return unit.companyName;
        }

        if (unit.directOwnerId === 0) {
            return 'N/A';
        }


        const ownerId = unit.directOwnerId !== null ? unit.directOwnerId : unit.ownerId;
        const owner = this.$store.getters['User/getCacheUser'](ownerId);

        return (owner) ? this.$store.getters['User/getCacheUser'](ownerId).fullName : '';
    }

    public forWholeCorporationChanged(ev: any) {
        if (this.recipientSelected) {
            return false;
        }

        if (ev.srcElement.checked) {
            this.noRecipientsError = false;
        }

        this.$store.commit(Mutations.SET_FOR_WHOLE_CORPORATION, ev.srcElement.checked);
    }

    public checkOrUncheckAllRecipients(ev: any) {
        for (const checkbox of document.getElementsByTagName('input')) {
            if (checkbox.classList.contains('recipients-check-item')) {
                checkbox.checked = ev.srcElement.checked;
            }
        }

        if (ev.srcElement.checked) {
            this.recipientsSelectedUnits = cloneDeep(this.properties);
        } else {
            this.recipientsSelectedUnits = [];
        }
    }

    public setRecipientUnits(ev: any, unit: PropertyData) {
        if (ev.srcElement.checked) {
            this.recipientsSelectedUnits.push(unit);
        } else {
            this.recipientsSelectedUnits = this.recipientsSelectedUnits.filter((property: any) => {
                return property.id !== unit.id;
            });
        }
    }

    public clearSelectedProjects() {
        this.recipientsSelectedProjects = [];
    }

    public clearSelectedGroups() {
        this.recipientsSelectedGroups = [];
    }

    public clearSelectedUnits() {
        this.recipientsSelectedUnits = [];
        this.preselectedUnitIds      = [];

        for (const checkbox of document.getElementsByTagName('input')) {
            if (checkbox.classList.contains('recipients-checkbox-all')) {
                checkbox.checked = false;
            }
        }
    }

    public addRecipients() {
        const data = {
            projects: this.recipientsSelectedProjects,
            groups: this.recipientsSelectedGroups,
            units: this.recipientsSelectedUnits,
        };

        if (this.recipientRequired && (!data.projects.length && !data.groups.length && !data.units.length) && !this.isForWholeCorporation) {
            this.noRecipientsError = true;
            return false;
        }

        this.$store.commit(Mutations.SET_SELECTED_RECIPIENTS, data);
        this.$store.commit(Mutations.SET_RECIPIENTS_VISIBILITY, false);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_RECIPIENTS_VISIBILITY, false);
    }

    public created() {
        // Set preselected recipients
        const preselectedRecipients = cloneDeep(this.$store.getters['Recipients/getSelectedRecipients']);

        this.recipientsSelectedProjects = preselectedRecipients.projects.length ? preselectedRecipients.projects : [];
        this.recipientsSelectedGroups   = preselectedRecipients.groups.length ? preselectedRecipients.groups : [];
        this.recipientsSelectedUnits    = preselectedRecipients.units.length ? preselectedRecipients.units : [];

        // Set preselected action targets
        for (const project of this.preselectedActionTargets.projects) {
            if (!this.recipientsSelectedProjects.some((recipient: any) => recipient.id === project.id)) {
                this.recipientsSelectedProjects.push(project);
            }
        }
        for (const building of this.preselectedActionTargets.groups) {
            if (!this.recipientsSelectedGroups.some((recipient: any) => recipient.id === building.id)) {
                this.recipientsSelectedGroups.push(building);
            }
        }
        for (const property of this.preselectedActionTargets.units) {
            if (!this.recipientsSelectedUnits.some((recipient: any) => recipient.id === property.id)) {
                this.recipientsSelectedUnits.push(property);
            }
        }

        // Set preselected units checkbox option
        if (this.recipientsSelectedUnits.length) {
            this.preselectedUnitIds = this.recipientsSelectedUnits.map((unit: any) => unit.id);
        }
    }
}
